

import Cookies from "js-cookie";

const BASE_URL = "https://uptask.visiontrek.io/api";
// const BASE_URL = "http://localhost:5555/api";
// const BASE_URL = "http://192.168.1.16:6655/api";
// const BASE_URL = "/api";
export const FILE_BASE_URL = "https://uptask.visiontrek.io";
/* ================= CORE REQUEST ================= */

async function request(url, options = {}) {
  const token = Cookies.get("token");
  console.log(`[API REQUEST] URL: ${url} | Token exists: ${!!token}`);

  const res = await fetch(`${BASE_URL}${url}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      ...(options.body instanceof FormData
        ? {} // don't set content-type for multipart
        : { "Content-Type": "application/json" }),
      ...options.headers,
    },
    ...options,
  });

  let data = {};
  if (res.status !== 204) {
    try {
      data = await res.json();
    } catch (e) {
      // Not JSON
    }
  }

  if (res.status === 403) {
    return { forbidden: true };
  }

  if (!res.ok) {
    throw new Error(data.message || `Request failed with status ${res.status}`);
  }


  return data;
}

/* ================= AUTH ================= */

export const loginApi = (body) =>
  request("/users/login", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const saveLoginLocationApi = (body) =>
  request("/attendance/admin-attendance/save-login-location", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const getProfileApi = () =>
  request("/users/me");

export const getChatUnreadApi = () =>
  request("/chat/unread");

export const getPublicScreenshotsApi = () =>
  request("/screenshots/public");

// export const updateOfficeExpenseApi = (id, formData) =>
// request(`/office-expense/${id}`, {
//   method: "PUT",
//   body: formData,
// });


// export const updateOwnProfileApi = async (payload) => {
//   const token = Cookies.get("token");

//   const res = await fetch(`${BASE_URL}/users/me`, {
//     method: "PUT",
//     headers: {
//       Authorization: `Bearer ${token}`,
//       // ❌ DO NOT set Content-Type
//     },
//     body: payload, // 👈 FormData directly
//   });

//   return res.json();
// };

export const updateOwnProfileApi = async (payload) => {
  const res = await fetch(`${BASE_URL}/users/me`, {
    method: "PUT",
    credentials: "include",   // ✅ THIS IS THE KEY FIX
    body: payload,
  });

  return res.json();
};


/* ================= USERS ================= */

export const getUserByIdApi = (id) =>
  request(`/users?id=${id}`);

export const getEmployeesApi = () =>
  request("/users");

export const createUserApi = (payload) =>
  request("/users", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateUserApi = (id, payload) =>
  request(`/users/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteUserApi = (id) =>
  request(`/users/${id}`, {
    method: "DELETE",
  });

export const getExEmployeesApi = () =>
  request("/users/ex");




export const resetUserPasswordApi = async (userId, newPassword) => {
  const token = Cookies.get("token");

  const res = await fetch(
    `${BASE_URL}/users/${userId}/reset-password`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        new_password: newPassword,
      }),
    }
  );

  return res.json();
};


/* ================= DEPARTMENTS ================= */

export const createDepartmentApi = (payload) =>
  request("/departments", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getDepartmentsApi = () =>
  request("/departments");

export const updateDepartmentApi = (id, payload) =>
  request(`/departments/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteDepartmentApi = (id) =>
  request(`/departments/${id}`, {
    method: "DELETE",
  });

/* ================= DASHBOARD ================= */

export const getDashboardFeedsApi = () =>
  request("/dashboard/feeds");

/* ================= ATTENDANCE ================= */

export const punchInApi = (formData) =>
  request("/attendance/user-punch-in", {
    method: "POST",
    body: formData,
  });

export const punchOutApi = (formData) =>
  request("/attendance/user-punch-out", {
    method: "POST",
    body: formData,
  });


export const autoPunchOutApi = () =>
  request("/attendance/auto-punch-out", {
    method: "POST",
  });

export const startBreakApi = () =>
  request("/attendance/user-break/start", {
    method: "POST",
  });

export const endBreakApi = () =>
  request("/attendance/user-break/end", {
    method: "POST",
  });

// export const getMyAttendanceApi = () =>
//   request("/attendance/user-my");


export const getMyAttendanceApi = (month, year) =>
  request(`/attendance/user-my?month=${month}&year=${year}`);

export const getMonthlySummaryApi = (month, year) =>
  request(
    `/attendance/user-summary/monthly?month=${month}&year=${year}`
  );

/* ================= ADMIN ATTENDANCE ================= */

export const adminDailyAttendanceApi = (date) =>
  request(`/attendance/admin-attendance/day?date=${date}`);

export const adminMonthlyAttendanceApi = (month, year) =>
  request(
    `/attendance/admin-attendance/monthly?month=${month}&year=${year}`
  );


// ✅ USER MONTHLY DAILY ATTENDANCE (ADMIN)
export const getUserMonthlyDailyAttendanceApi = (userId, month, year) =>
  request(
    `/attendance/admin-attendance/user-monthly-daily?user_id=${userId}&month=${month}&year=${year}`
  );


// http://localhost:5566/api/attendance/admin-attendance/user-monthly-daily?user_id=19&month=4&year=2026 

/* ================= LEAVES ================= */

export const getLeaveTypesApi = () =>
  request("/leave/types");

export const getLeaveBalanceApi = () =>
  request("/leave/balance");

export const applyLeaveApi = (payload) =>
  request("/leave/apply", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getMyLeavesApi = () =>
  request("/leave/my");

export const cancelLeaveApi = (id) =>
  request(`/leave/cancel/${id}`, {
    method: "POST",
  });

/* ================= ADMIN LEAVES ================= */

export const adminPendingLeavesApi = () =>
  request("/leave/pending");

export const adminApproveLeaveApi = (leave_id) =>
  request("/leave/approve", {
    method: "POST",
    body: JSON.stringify({ leave_id }),
  });

export const adminRejectLeaveApi = (leave_id, remarks) =>
  request("/leave/reject", {
    method: "POST",
    body: JSON.stringify({ leave_id, remarks }),
  });

// export const adminLeaveReportApi = (filters = {}) => {
//   const params = {
//     employee_id: filters.search || "",
//     status:
//       filters.status !== ""
//         ? Number(filters.status)
//         : "",
//     from_date: filters.start_date || "",
//     to_date: filters.end_date || "",
//   };

//   const cleanParams = Object.fromEntries(
//     Object.entries(params).filter(([_, v]) => v !== "")
//   );

//   const query = new URLSearchParams(cleanParams).toString();

//   return request(`/leave/report?${query}`);
// };
export const adminLeaveReportApi = () => {
  return request(`/leave/report`);
};
/* ================= EXPENSES ================= */

export const createExpenseCategoryApi = (payload) =>
  request("/office-expense/category", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getExpenseCategoriesApi = () =>
  request("/office-expense/category");

export const updateExpenseCategoryApi = (id, payload) =>
  request(`/office-expense/category/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteExpenseCategoryApi = (id) =>
  request(`/office-expense/category/${id}`, {
    method: "DELETE",
  });

export const addOfficeExpenseApi = (formData) =>
  request("/office-expense", {
    method: "POST",
    body: formData,
  });

export const listOfficeExpensesApi = () =>
  request("/office-expense");

export const updateOfficeExpenseApi = (id, formData) =>
  request(`/office-expense/${id}`, {
    method: "PUT",
    body: formData,
  });

export const deleteOfficeExpenseApi = (id) =>
  request(`/office-expense/${id}`, {
    method: "DELETE",
  });

export const addOfficeWalletApi = (payload) =>
  request("/office-expense/wallet", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getOfficeWalletHistoryApi = () =>
  request("/office-expense/wallet");

export const deleteOfficeWalletApi = (id) =>
  request(`/office-expense/wallet/${id}`, {
    method: "DELETE",
  });

export const getOfficeExpenseSummaryApi = () =>
  request("/office-expense/summary");

/* ================= TASKS ================= */

export const getMyTasksApi = () =>
  request("/tasks/my");

export const getAllTasksApi = () =>
  request("/tasks/all");

// export const getTeamTasksApi = () =>
//   request("/tasks/team");

export const createTaskApi = (payload) =>
  request("/tasks", {
    method: "POST",
    body: JSON.stringify(payload),
  });

// export const updateTaskStatusApi = (taskId, payload) =>
//   request(`/tasks/${taskId}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });


// ✅ DELETE TASK
export const deleteTaskApi = (taskId) =>
  request(`/tasks/${taskId}`, {
    method: "DELETE",
  });


export const getAdminUserTasksApi = (userId) =>
  request(`/tasks/admin/user/${userId}`);


/* ================= TASKS ================= */

export const getAssignedTasksApi = () =>
  request("/tasks/assigned");


/* ================= SUBTASKS ================= */

export const getSubtasksApi = (taskId) =>
  request(`/tasks/${taskId}/subtasks`);

export const addSubtaskApi = (taskId, payload) =>
  request(`/tasks/${taskId}/subtasks`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const toggleSubtaskApi = (subtaskId, payload) =>
  request(`/tasks/subtasks/${subtaskId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const updateSubtaskApi = (subtaskId, payload) =>
  request(`/tasks/subtasks/${subtaskId}/update`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteSubtaskApi = (subtaskId) =>
  request(`/tasks/subtasks/${subtaskId}/delete`, {
    method: "DELETE",
  });

/* ================= TASK ACTIVITY ================= */

export const getTaskActivityApi = (taskId) =>
  request(`/tasks/${taskId}/activity`);

/* ================= TASK COMMENTS ================= */

export const getTaskCommentsApi = (taskId) =>
  request(`/tasks/${taskId}/comments`);

export const addTaskCommentApi = (taskId, payload) =>
  request(`/tasks/${taskId}/comment`, {
    method: "POST",
    body: JSON.stringify(payload),
  });





// ======================dependanct task--------=====================
export const addSubtaskDependencyApi = (subtaskId, payload) =>
  request(`/tasks/subtasks/${subtaskId}/dependency`, {
    method: "POST",
    body: JSON.stringify(payload),
  });




/* ================= TEAM COLLABORATION ================= */

// 1. Create Team
export const createTeamApi = (payload) =>
  request("/teams", {
    method: "POST",
    body: JSON.stringify(payload),
  });

// 2. Get All Teams
export const getAllTeamsApi = () =>
  request("/teams");

// 3. Get Team Details
export const getTeamDetailsApi = (teamId) =>
  request(`/teams/${teamId}`);

// 4. Add Member
export const addTeamMemberApi = (teamId, payload) =>
  request(`/teams/${teamId}/members`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

// 5. Remove Member
export const removeTeamMemberApi = (teamId, userId) =>
  request(`/teams/${teamId}/members/${userId}`, {
    method: "DELETE",
  });

// 6. Create Team Task
export const createTeamTaskApi = (teamId, payload) =>
  request(`/teams/${teamId}/tasks`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

// 7. Get Team Tasks
export const getTeamTasksApi = (teamId, page = 1, limit = 20, status = "") =>
  request(
    `/teams/${teamId}/tasks?page=${page}&limit=${limit}&status=${status}`
  );


export const getTeamTasksApi1 = () =>
  request("/tasks/team");

// 8. Team Analytics
export const getTeamAnalyticsApi = (teamId) =>
  request(`/teams/${teamId}/analytics`);

// 9. Team Activity
export const getTeamActivityApi = (teamId, page = 1, limit = 20) =>
  request(`/teams/${teamId}/activity?page=${page}&limit=${limit}`);







/* ================= PAYROLL ================= */

// export const getEarningsApi = () =>
//   request("/admin/payroll/earnings");

// export const addEarningApi = (payload) =>
//   request("/admin/payroll/earnings", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

export const createSalaryApi = (payload) =>
  request("/admin/payroll/salary", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const listSalariesApi = () =>
  request("/admin/payroll/salary");

export const getSalaryBreakdownApi = (uuid) =>
  request(`/admin/payroll/salary/${uuid}`);



// export const getPayrollSummaryApi = (fromMonth, toMonth) => {
//   if (toMonth) {
//     return request(`/payroll/summary?month=${fromMonth}&fromMonth=${fromMonth}&toMonth=${toMonth}`);
//   }
//   return request(`/payroll/summary?month=${fromMonth}`);
// };

export const getPayrollSummaryApi = (fromMonth, toMonth) => {
  if (toMonth) {
    return request(`/payroll/summary?fromMonth=${fromMonth}&toMonth=${toMonth}`);
  }
  request(`/payroll/summary?month=${fromMonth}`);
};

export const getPayrollRecordsApi = (fromMonth, toMonth) => {
  if (toMonth) {
    return request(`/payroll/monthly?fromMonth=${fromMonth}&toMonth=${toMonth}`);
  }
  return request(`/payroll/monthly?month=${fromMonth}`);
};

export const runPayrollApi = (payload) =>
  request("/payroll/run", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getPayrollEmployeesApi = (month) =>
  request(`/payroll/employees${month ? `?month=${month}` : ""}`);

export const updatePayrollDetailsApi = (payload) =>
  request("/payroll/details", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const editPayrollEmployeeApi = (id, payload) =>
  request(`/payroll/employee/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const rerunPayrollApi = (payload) =>
  request("/payroll/rerun", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const approvePayrollApi = (payload) =>
  request("/payroll/approve", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const markPayrollPaidApi = (payload) =>
  request("/payroll/paid", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const exportPayrollReportApi = async (fromMonth, toMonth) => {
  const token = Cookies.get("token");
  const url = toMonth
    ? `${BASE_URL}/payroll/export?fromMonth=${fromMonth}&toMonth=${toMonth}`
    : `${BASE_URL}/payroll/export?month=${fromMonth}`;
  const res = await fetch(url, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  if (!res.ok) throw new Error("Failed to export report");

  const blob = await res.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = `Payroll_Report_${fromMonth}${toMonth ? `_to_${toMonth}` : ""}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

export const getPayslipApi = (userId, month, year) =>
  request(`/payroll/payslip?userId=${userId}&month=${month}&year=${year}`);

export const getAllPayslipsApi = () =>
  request("/payroll/all-payslips");


/* ================= PAYROLL BONUS ================= */

export const addBonusApi = (payload) =>
  request("/payroll/bonus", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getMonthlyBonusApi = (month) =>
  request(`/payroll/viewbonus?month=${month}`);

export const updateBonusApi = (id, payload) =>
  request(`/payroll/bonus/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteBonusApi = (id) =>
  request(`/payroll/bonus/${id}`, {
    method: "DELETE",
  });

export const getLeaveSummaryApi = (employeeId) =>
  request(`/leave/summary?employee_id=${employeeId}`);


export const getUserMonthlyAttendanceApi = (month, year, employeeId) => {
  let url = `/attendance/user-summary/monthly?month=${month}&year=${year}`;

  if (employeeId) {
    url += `&employee_id=${employeeId}`;
  }

  return request(url);
};






/* ================= ADMIN TASK ANALYTICS ================= */

export const adminTaskAnalyticsApi = (filters = {}) => {
  const params = {
    completed:
      filters.completed !== undefined
        ? filters.completed
        : "",
    priority: filters.priority || "",
    created_from: filters.created_from || "",
    created_to: filters.created_to || "",
    assigned_to: filters.assigned_to || "",
    search: filters.search || "",
  };

  // remove empty values
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== "")
  );

  const query = new URLSearchParams(cleanParams).toString();

  return request(`/tasks/admin/analytics?${query}`);
};




// ==========================posts===========================
/* ================= FEEDS ================= */

export const createFeedApi = (payload, isFormData = false) => {
  const token = Cookies.get("token"); // ✅ get token
  return fetch(`${BASE_URL}/feeds`, {
    method: "POST",
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      Authorization: `Bearer ${token}`, // ✅ always send token
    },
    body: payload,
  }).then((res) => res.json());
};



export const getFeedsApi = () =>
  request("/feeds");

export const deleteFeedApi = (id) =>
  request(`/feeds/${id}`, {
    method: "DELETE",
  });

export const likeFeedApi = (id) =>
  request(`/feeds/${id}/like`, {
    method: "POST",
  });

export const unlikeFeedApi = (id) =>
  request(`/feeds/${id}/like`, {
    method: "DELETE",
  });

//   export const likeFeedApi = (id) =>
//   request(/feeds/${id}/like, {
//     method: "POST",
//   });

// export const unlikeFeedApi = (id) =>
//   request(/feeds/${id}/like, {
//     method: "POST",
//   });

export const addCommentApi = (id, payload) =>
  request(`/feeds/${id}/comment`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getCommentsApi = (id) =>
  request(`/feeds/${id}/comments`);

export const deleteCommentApi = (commentId) =>
  request(`/feeds/comment/${commentId}`, {
    method: "DELETE",
  });

/* ================= DOCUMENTS ================= */

// Upload single document
export const uploadDocumentApi = (formData) =>
  request("/documents", {
    method: "POST",
    body: formData,
  });

// Upload multiple documents
export const bulkUploadDocumentsApi = (formData) =>
  request("/documents/bulk-upload", {
    method: "POST",
    body: formData,
    // body: JSON.stringify(payload),
    // body: JSON.stringify(payload),
  });

export const deleteMessageApi = (messageId) =>
  request(`/chat/messages/${messageId}`, {
    method: "DELETE",
  });

// Get documents for specific user
export const getUserDocumentsApi = (userId) =>
  request(`/documents/user/${userId}`);

// View document
export const viewDocumentApi = (userId) =>
  request(`/documents/view/${userId}`);

// export const viewDocumentApi = (userId) =>
export const getAllDocumentsApi = () =>
  request(`/documents/all`);

// Delete document
export const deleteDocumentApi = (id) =>
  request(`/documents/${id}`, {
    method: "DELETE",
  });

/* ================= MONTHLY TASKS ================= */

export const getMyMonthlyTasksApi = (month, year) =>
  request(`/monthly-tasks/my?month=${month}&year=${year}`);

export const setEmployeeOfTheMonthApi = (payload) =>
  request("/monthly-tasks/employee-of-the-month", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const getMonthlyLeaderboardApi = (month, year) =>
  request(`/monthly-tasks/leaderboard?month=${month || ""}&year=${year || ""}`);

export const getAllMonthlyReportsApi = (month, year) =>
  request(`/monthly-tasks/all-reports?month=${month || ""}&year=${year || ""}`);

export const completeMonthlyTaskApi = (id) =>
  request(`/monthly-tasks/${id}/complete`, {
    method: "POST",
  });

export const AdminMonthlyAttendanceApi = (month, year) =>
  request(
    `/attendance/admin-attendance/monthly-summary-table?month=${month}&year=${year}`
  );







/* ================= PROJECT APIs ================= */



// export const createProjectApi = (formData) =>
//   request("/Projects", {
//     method: "POST",
//     body: formData, // ✅ send FormData directly
//   });



// // ✅ GET ALL PROJECTS (if needed later)
// export const getProjectsApi = () =>
//   request("/Projects");




// // ✅ GET MY PROJECTS (logged-in user)
// export const getMyProjectsApi = () =>
//   request("/Projects/my");


// // ✅ GET PROJECT BY ID (optional)
// export const getProjectByIdApi = (id) =>
//   request(`/Projects/${id}`);



// export const updateProjectApi = (id, data) =>
//   request(`/Projects/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(data), // ✅ FIXED
//   });

// // ✅ DELETE
// export const deleteProjectApi = (id) =>
//   request(`/Projects/${id}`, {
//     method: "DELETE",
//   });







// ✅ CREATE APP
export const createAppApi = (payload) =>
  request("/appProjects", {
    method: "POST",
    body: JSON.stringify(payload),
  });


export const getAppProjectsApi = () =>
  request("/appProjects");

// ✅ GET APP BY ID
export const getAppProjectsmyapi = () =>
  request("/appProjects/my");









// ✅ 🔥 UPDATE APP (ADD THIS)
export const updateAppProjectApi = (id, payload) =>
  request(`/appProjects/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });


// ✅ 🔥 DELETE APP (ADD THIS)
export const deleteAppProjectApi = (id) =>
  request(`/appProjects/${id}`, {
    method: "DELETE",
  });






// ✅ CREATE PROJECT
export const createProjectApi = (formData) =>
  request("/allProjects", {
    method: "POST",
    body: formData, // ✅ send FormData directly
  });

export const createDemoProjectApi = (body) =>
  request("/demoProjects", {
    method: "POST",
    body: JSON.stringify(body),
  });

// http://localhost:6655/api/demoProjects

export const getallDemoProjectsApi = () =>
  request("/demoProjects");

export const getDemoProjectsApi = () =>
  request("/demoProjects/my");

export const updateDemoProjectApi = (id, body) =>
  request(`/demoProjects/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const deleteDemoProjectApi = (id) =>
  request(`/demoProjects/${id}`, {
    method: "DELETE",
  });

// ✅ GET ALL PROJECTS
export const getProjectsApi = () =>
  request("/allProjects");

// ✅ GET MY PROJECTS (logged-in user)
export const getMyProjectsApi = () =>
  request("/allProjects/my");

// ✅ GET PROJECT BY ID
// export const getProjectByIdApi = (id) =>
//   request(/allProjects/${id});

export const getProjectByIdApi = (id) =>
  request(`/allProjects/${id}`);

// ✅ UPDATE
export const updateProjectApi = (id, formData) =>
  request(`/allProjects/${id}`, {
    method: "PUT",
    body: formData,
  });

// ✅ DELETE
export const deleteProjectApi = (id) =>
  request(`/allProjects/${id}`, {
    method: "DELETE",
  });






/* ================= CHAT ================= */

// 📥 Get chat history (user or group)
export const getChatHistoryApi = ({ userId, groupId }) => {
  if (groupId) {
    return request(`/chat/groups/${groupId}/messages`);
  }
  if (userId) {
    return request(`/chat/history/${userId}`);
  }
};

// 👥 Get chat users
export const getChatUsersApi = (search = "") =>
  request(`/chat/users${search ? `?search=${encodeURIComponent(search)}` : ""}`);

// 👨‍👩‍👧‍👦 Get groups
export const getChatGroupsApi = () =>
  request("/chat/groups");

// ➕ Create group
export const createChatGroupApi = (payload) =>
  request("/chat/groups", {
    method: "POST",
    body: JSON.stringify(payload),
  });

// ❌ Delete group
export const deleteChatGroupApi = (groupId) =>
  request(`/chat/groups/${groupId}`, {
    method: "DELETE",
  });

// 👥 Get group members
export const getGroupMembersApi = (groupId) =>
  request(`/chat/groups/${groupId}/members`);

// ➕ Add member to group
export const addGroupMemberApi = (groupId, userId) =>
  request(`/chat/groups/${groupId}/members`, {
    method: "POST",
    body: JSON.stringify({ userId }),
  });

// ❌ Remove member from group
export const removeGroupMemberApi = (groupId, userId) =>
  request(`/chat/groups/${groupId}/members/${userId}`, {
    method: "DELETE",
  });
// ======journey====
// export const getTaskActivityApi = (taskId) =>
// request(`/tasks/${taskId}/activity`);

export const getUserActivityApi = (userId) =>
  request(`/tasks/user/${userId}/activity`);

export const chatBulkUploadApi = (formData) =>
  request("/documents/chat-bulk-upload", {
    method: "POST",
    body: formData,
  });


export const updateTaskStatusApi = (taskId, payload) =>
  request(`/tasks/${taskId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });


/* ================= GRIEVANCE ================= */

export const getGrievancesApi = () =>
  request("/grievance");

export const createGrievanceApi = (formData) =>
  request("/grievance", {
    method: "POST",
    body: formData,
  });

export const updateGrievanceStatusApi = (id, payload) =>
  request(`/grievance/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });







// import Cookies from "js-cookie";

// // const BASE_URL = "https://uptask.visiontrek.io/api";
// // const BASE_URL = "http://localhost:6655/api";
// const BASE_URL = "http://192.168.1.16:6655/api";
// // const BASE_URL = "/api";
// export const FILE_BASE_URL = "https://uptask.visiontrek.io";
// /* ================= CORE REQUEST ================= */

// async function request(url, options = {}) {
//   const token = Cookies.get("token");

//   const res = await fetch(`${BASE_URL}${url}`, {
//     headers: {
//       Authorization: token ? `Bearer ${token}` : "",
//       ...(options.body instanceof FormData
//         ? {} // don't set content-type for multipart
//         : { "Content-Type": "application/json" }),
//       ...options.headers,
//     },
//     ...options,
//   });

//   let data = {};
//   if (res.status !== 204) {
//     try {
//       data = await res.json();
//     } catch (e) {
//       // Not JSON
//     }
//   }

//   if (res.status === 403) {
//     return { forbidden: true };
//   }

//   if (!res.ok) {
//     throw new Error(data.message || `Request failed with status ${res.status}`);
//   }


//   return data;
// }

// /* ================= AUTH ================= */

// export const loginApi = (body) =>
//   request("/users/login", {
//     method: "POST",
//     body: JSON.stringify(body),
//   });

// export const getProfileApi = () =>
//   request("/users/me");

// export const getChatUnreadApi = () =>
//   request("/chat/unread");

// // export const updateOfficeExpenseApi = (id, formData) =>
// // request(`/office-expense/${id}`, {
// //   method: "PUT",
// //   body: formData,
// // });


// // export const updateOwnProfileApi = async (payload) => {
// //   const token = Cookies.get("token");

// //   const res = await fetch(`${BASE_URL}/users/me`, {
// //     method: "PUT",
// //     headers: {
// //       Authorization: `Bearer ${token}`,
// //       // ❌ DO NOT set Content-Type
// //     },
// //     body: payload, // 👈 FormData directly
// //   });

// //   return res.json();
// // };

// export const updateOwnProfileApi = async (payload) => {
//   const res = await fetch(`${BASE_URL}/users/me`, {
//     method: "PUT",
//     credentials: "include",   // ✅ THIS IS THE KEY FIX
//     body: payload,
//   });

//   return res.json();
// };


// /* ================= USERS ================= */

// export const getUserByIdApi = (id) =>
//   request(`/users?id=${id}`);

// export const getEmployeesApi = () =>
//   request("/users");

// export const createUserApi = (payload) =>
//   request("/users", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const updateUserApi = (id, payload) =>
//   request(`/users/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteUserApi = (id) =>
//   request(`/users/${id}`, {
//     method: "DELETE",
//   });

// export const getExEmployeesApi = () =>
//   request("/users/ex");




// export const resetUserPasswordApi = async (userId, newPassword) => {
//   const token = Cookies.get("token");

//   const res = await fetch(
//     `${BASE_URL}/users/${userId}/reset-password`,
//     {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify({
//         new_password: newPassword,
//       }),
//     }
//   );

//   return res.json();
// };


// /* ================= DEPARTMENTS ================= */

// export const createDepartmentApi = (payload) =>
//   request("/departments", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getDepartmentsApi = () =>
//   request("/departments");

// export const updateDepartmentApi = (id, payload) =>
//   request(`/departments/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteDepartmentApi = (id) =>
//   request(`/departments/${id}`, {
//     method: "DELETE",
//   });

// /* ================= DASHBOARD ================= */

// export const getDashboardFeedsApi = () =>
//   request("/dashboard/feeds");

// /* ================= ATTENDANCE ================= */

// export const punchInApi = (formData) =>
//   request("/attendance/user-punch-in", {
//     method: "POST",
//     body: formData,
//   });

// export const punchOutApi = (formData) =>
//   request("/attendance/user-punch-out", {
//     method: "POST",
//     body: formData,
//   });


// export const autoPunchOutApi = () =>
//   request("/attendance/auto-punch-out", {
//     method: "POST",
//   });

// export const startBreakApi = () =>
//   request("/attendance/user-break/start", {
//     method: "POST",
//   });

// export const endBreakApi = () =>
//   request("/attendance/user-break/end", {
//     method: "POST",
//   });

// // export const getMyAttendanceApi = () =>
// //   request("/attendance/user-my");


// export const getMyAttendanceApi = (month, year) =>
//   request(`/attendance/user-my?month=${month}&year=${year}`);

// export const getMonthlySummaryApi = (month, year) =>
//   request(
//     `/attendance/user-summary/monthly?month=${month}&year=${year}`
//   );

// /* ================= ADMIN ATTENDANCE ================= */

// export const adminDailyAttendanceApi = (date) =>
//   request(`/attendance/admin-attendance/day?date=${date}`);

// export const adminMonthlyAttendanceApi = (month, year) =>
//   request(
//     `/attendance/admin-attendance/monthly?month=${month}&year=${year}`
//   );


// // ✅ USER MONTHLY DAILY ATTENDANCE (ADMIN)
// export const getUserMonthlyDailyAttendanceApi = (userId, month, year) =>
//   request(
//     `/attendance/admin-attendance/user-monthly-daily?user_id=${userId}&month=${month}&year=${year}`
//   );


// // http://localhost:5566/api/attendance/admin-attendance/user-monthly-daily?user_id=19&month=4&year=2026

// /* ================= LEAVES ================= */

// export const getLeaveTypesApi = () =>
//   request("/leave/types");

// export const getLeaveBalanceApi = () =>
//   request("/leave/balance");

// export const applyLeaveApi = (payload) =>
//   request("/leave/apply", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getMyLeavesApi = () =>
//   request("/leave/my");

// export const cancelLeaveApi = (id) =>
//   request(`/leave/cancel/${id}`, {
//     method: "POST",
//   });

// /* ================= ADMIN LEAVES ================= */

// export const adminPendingLeavesApi = () =>
//   request("/leave/pending");

// export const adminApproveLeaveApi = (leave_id) =>
//   request("/leave/approve", {
//     method: "POST",
//     body: JSON.stringify({ leave_id }),
//   });

// export const adminRejectLeaveApi = (leave_id, remarks) =>
//   request("/leave/reject", {
//     method: "POST",
//     body: JSON.stringify({ leave_id, remarks }),
//   });

// // export const adminLeaveReportApi = (filters = {}) => {
// //   const params = {
// //     employee_id: filters.search || "",
// //     status:
// //       filters.status !== ""
// //         ? Number(filters.status)
// //         : "",
// //     from_date: filters.start_date || "",
// //     to_date: filters.end_date || "",
// //   };

// //   const cleanParams = Object.fromEntries(
// //     Object.entries(params).filter(([_, v]) => v !== "")
// //   );

// //   const query = new URLSearchParams(cleanParams).toString();

// //   return request(`/leave/report?${query}`);
// // };
// export const adminLeaveReportApi = () => {
//   return request(`/leave/report`);
// };
// /* ================= EXPENSES ================= */

// export const createExpenseCategoryApi = (payload) =>
//   request("/office-expense/category", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getExpenseCategoriesApi = () =>
//   request("/office-expense/category");

// export const updateExpenseCategoryApi = (id, payload) =>
//   request(`/office-expense/category/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteExpenseCategoryApi = (id) =>
//   request(`/office-expense/category/${id}`, {
//     method: "DELETE",
//   });

// export const addOfficeExpenseApi = (formData) =>
//   request("/office-expense", {
//     method: "POST",
//     body: formData,
//   });

// export const listOfficeExpensesApi = () =>
//   request("/office-expense");

// export const updateOfficeExpenseApi = (id, formData) =>
//   request(`/office-expense/${id}`, {
//     method: "PUT",
//     body: formData,
//   });

// export const deleteOfficeExpenseApi = (id) =>
//   request(`/office-expense/${id}`, {
//     method: "DELETE",
//   });

// export const addOfficeWalletApi = (payload) =>
//   request("/office-expense/wallet", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getOfficeWalletHistoryApi = () =>
//   request("/office-expense/wallet");

// export const deleteOfficeWalletApi = (id) =>
//   request(`/office-expense/wallet/${id}`, {
//     method: "DELETE",
//   });

// export const getOfficeExpenseSummaryApi = () =>
//   request("/office-expense/summary");

// /* ================= TASKS ================= */

// export const getMyTasksApi = () =>
//   request("/tasks/my");

// export const getAllTasksApi = () =>
//   request("/tasks/all");

// // export const getTeamTasksApi = () =>
// //   request("/tasks/team");

// export const createTaskApi = (payload) =>
//   request("/tasks", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // export const updateTaskStatusApi = (taskId, payload) =>
// //   request(`/tasks/${taskId}`, {
// //     method: "PUT",
// //     body: JSON.stringify(payload),
// //   });


// // ✅ DELETE TASK
// export const deleteTaskApi = (taskId) =>
//   request(`/tasks/${taskId}`, {
//     method: "DELETE",
//   });


// export const getAdminUserTasksApi = (userId) =>
//   request(`/tasks/admin/user/${userId}`);


// /* ================= TASKS ================= */

// export const getAssignedTasksApi = () =>
//   request("/tasks/assigned");


// /* ================= SUBTASKS ================= */

// export const getSubtasksApi = (taskId) =>
//   request(`/tasks/${taskId}/subtasks`);

// export const addSubtaskApi = (taskId, payload) =>
//   request(`/tasks/${taskId}/subtasks`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const toggleSubtaskApi = (subtaskId, payload) =>
//   request(`/tasks/subtasks/${subtaskId}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const updateSubtaskApi = (subtaskId, payload) =>
//   request(`/tasks/subtasks/${subtaskId}/update`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteSubtaskApi = (subtaskId) =>
//   request(`/tasks/subtasks/${subtaskId}/delete`, {
//     method: "DELETE",
//   });

// /* ================= TASK ACTIVITY ================= */

// export const getTaskActivityApi = (taskId) =>
//   request(`/tasks/${taskId}/activity`);

// /* ================= TASK COMMENTS ================= */

// export const getTaskCommentsApi = (taskId) =>
//   request(`/tasks/${taskId}/comments`);

// export const addTaskCommentApi = (taskId, payload) =>
//   request(`/tasks/${taskId}/comment`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });





// // ======================dependanct task--------=====================
// export const addSubtaskDependencyApi = (subtaskId, payload) =>
//   request(`/tasks/subtasks/${subtaskId}/dependency`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });




// /* ================= TEAM COLLABORATION ================= */

// // 1. Create Team
// export const createTeamApi = (payload) =>
//   request("/teams", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // 2. Get All Teams
// export const getAllTeamsApi = () =>
//   request("/teams");

// // 3. Get Team Details
// export const getTeamDetailsApi = (teamId) =>
//   request(`/teams/${teamId}`);

// // 4. Add Member
// export const addTeamMemberApi = (teamId, payload) =>
//   request(`/teams/${teamId}/members`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // 5. Remove Member
// export const removeTeamMemberApi = (teamId, userId) =>
//   request(`/teams/${teamId}/members/${userId}`, {
//     method: "DELETE",
//   });

// // 6. Create Team Task
// export const createTeamTaskApi = (teamId, payload) =>
//   request(`/teams/${teamId}/tasks`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // 7. Get Team Tasks
// export const getTeamTasksApi = (teamId, page = 1, limit = 20, status = "") =>
//   request(
//     `/teams/${teamId}/tasks?page=${page}&limit=${limit}&status=${status}`
//   );


// export const getTeamTasksApi1 = () =>
//   request("/tasks/team");

// // 8. Team Analytics
// export const getTeamAnalyticsApi = (teamId) =>
//   request(`/teams/${teamId}/analytics`);

// // 9. Team Activity
// export const getTeamActivityApi = (teamId, page = 1, limit = 20) =>
//   request(`/teams/${teamId}/activity?page=${page}&limit=${limit}`);







// /* ================= PAYROLL ================= */

// // export const getEarningsApi = () =>
// //   request("/admin/payroll/earnings");

// // export const addEarningApi = (payload) =>
// //   request("/admin/payroll/earnings", {
// //     method: "POST",
// //     body: JSON.stringify(payload),
// //   });

// export const createSalaryApi = (payload) =>
//   request("/admin/payroll/salary", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const listSalariesApi = () =>
//   request("/admin/payroll/salary");

// export const getSalaryBreakdownApi = (uuid) =>
//   request(`/admin/payroll/salary/${uuid}`);



// // export const getPayrollSummaryApi = (fromMonth, toMonth) => {
// //   if (toMonth) {
// //     return request(`/payroll/summary?month=${fromMonth}&fromMonth=${fromMonth}&toMonth=${toMonth}`);
// //   }
// //   return request(`/payroll/summary?month=${fromMonth}`);
// // };

// export const getPayrollSummaryApi = (fromMonth, toMonth) => {
//   if (toMonth) {
//     return request(`/payroll/summary?fromMonth=${fromMonth}&toMonth=${toMonth}`);
//   }
//   request(`/payroll/summary?month=${fromMonth}`);
// };

// export const getPayrollRecordsApi = (fromMonth, toMonth) => {
//   if (toMonth) {
//     return request(`/payroll/monthly?fromMonth=${fromMonth}&toMonth=${toMonth}`);
//   }
//   return request(`/payroll/monthly?month=${fromMonth}`);
// };

// export const runPayrollApi = (payload) =>
//   request("/payroll/run", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getPayrollEmployeesApi = (month) =>
//   request(`/payroll/employees${month ? `?month=${month}` : ""}`);

// export const updatePayrollDetailsApi = (payload) =>
//   request("/payroll/details", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const editPayrollEmployeeApi = (id, payload) =>
//   request(`/payroll/employee/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const rerunPayrollApi = (payload) =>
//   request("/payroll/rerun", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const approvePayrollApi = (payload) =>
//   request("/payroll/approve", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const markPayrollPaidApi = (payload) =>
//   request("/payroll/paid", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const exportPayrollReportApi = async (fromMonth, toMonth) => {
//   const token = Cookies.get("token");
//   const url = toMonth
//     ? `${BASE_URL}/payroll/export?fromMonth=${fromMonth}&toMonth=${toMonth}`
//     : `${BASE_URL}/payroll/export?month=${fromMonth}`;
//   const res = await fetch(url, {
//     headers: {
//       Authorization: token ? `Bearer ${token}` : "",
//     },
//   });

//   if (!res.ok) throw new Error("Failed to export report");

//   const blob = await res.blob();
//   const downloadUrl = window.URL.createObjectURL(blob);
//   const link = document.createElement('a');
//   link.href = downloadUrl;
//   link.download = `Payroll_Report_${fromMonth}${toMonth ? `_to_${toMonth}` : ""}.xlsx`;
//   document.body.appendChild(link);
//   link.click();
//   link.remove();
//   window.URL.revokeObjectURL(downloadUrl);
// };

// export const getPayslipApi = (userId, month, year) =>
//   request(`/payroll/payslip?userId=${userId}&month=${month}&year=${year}`);

// export const getAllPayslipsApi = () =>
//   request("/payroll/all-payslips");


// /* ================= PAYROLL BONUS ================= */

// export const addBonusApi = (payload) =>
//   request("/payroll/bonus", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getMonthlyBonusApi = (month) =>
//   request(`/payroll/viewbonus?month=${month}`);

// export const updateBonusApi = (id, payload) =>
//   request(`/payroll/bonus/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteBonusApi = (id) =>
//   request(`/payroll/bonus/${id}`, {
//     method: "DELETE",
//   });

// export const getLeaveSummaryApi = (employeeId) =>
//   request(`/leave/summary?employee_id=${employeeId}`);


// export const getUserMonthlyAttendanceApi = (month, year, employeeId) => {
//   let url = `/attendance/user-summary/monthly?month=${month}&year=${year}`;

//   if (employeeId) {
//     url += `&employee_id=${employeeId}`;
//   }

//   return request(url);
// };






// /* ================= ADMIN TASK ANALYTICS ================= */

// export const adminTaskAnalyticsApi = (filters = {}) => {
//   const params = {
//     completed:
//       filters.completed !== undefined
//         ? filters.completed
//         : "",
//     priority: filters.priority || "",
//     created_from: filters.created_from || "",
//     created_to: filters.created_to || "",
//     assigned_to: filters.assigned_to || "",
//     search: filters.search || "",
//   };

//   // remove empty values
//   const cleanParams = Object.fromEntries(
//     Object.entries(params).filter(([_, v]) => v !== "")
//   );

//   const query = new URLSearchParams(cleanParams).toString();

//   return request(`/tasks/admin/analytics?${query}`);
// };




// // ==========================posts===========================
// /* ================= FEEDS ================= */

// export const createFeedApi = (payload, isFormData = false) => {
//   const token = Cookies.get("token"); // ✅ get token
//   return fetch(`${BASE_URL}/feeds`, {
//     method: "POST",
//     headers: {
//       ...(isFormData ? {} : { "Content-Type": "application/json" }),
//       Authorization: `Bearer ${token}`, // ✅ always send token
//     },
//     body: payload,
//   }).then((res) => res.json());
// };



// export const getFeedsApi = () =>
//   request("/feeds");

// export const deleteFeedApi = (id) =>
//   request(`/feeds/${id}`, {
//     method: "DELETE",
//   });

// export const likeFeedApi = (id) =>
//   request(`/feeds/${id}/like`, {
//     method: "POST",
//   });

// export const unlikeFeedApi = (id) =>
//   request(`/feeds/${id}/like`, {
//     method: "DELETE",
//   });

// //   export const likeFeedApi = (id) =>
// //   request(/feeds/${id}/like, {
// //     method: "POST",
// //   });

// // export const unlikeFeedApi = (id) =>
// //   request(/feeds/${id}/like, {
// //     method: "POST",
// //   });

// export const addCommentApi = (id, payload) =>
//   request(`/feeds/${id}/comment`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getCommentsApi = (id) =>
//   request(`/feeds/${id}/comments`);

// export const deleteCommentApi = (commentId) =>
//   request(`/feeds/comment/${commentId}`, {
//     method: "DELETE",
//   });

// /* ================= DOCUMENTS ================= */

// // Upload single document
// export const uploadDocumentApi = (formData) =>
//   request("/documents", {
//     method: "POST",
//     body: formData,
//   });

// // Upload multiple documents
// export const bulkUploadDocumentsApi = (formData) =>
//   request("/documents/bulk-upload", {
//     method: "POST",
//     body: formData,
//     // body: JSON.stringify(payload),
//     // body: JSON.stringify(payload),
//   });

// export const deleteMessageApi = (messageId) =>
//   request(`/chat/messages/${messageId}`, {
//     method: "DELETE",
//   });

// // Get documents for specific user
// export const getUserDocumentsApi = (userId) =>
//   request(`/documents/user/${userId}`);

// // View document
// export const viewDocumentApi = (userId) =>
//   request(`/documents/view/${userId}`);

// // export const viewDocumentApi = (userId) =>
// export const getAllDocumentsApi = () =>
//   request(`/documents/all`);

// // Delete document
// export const deleteDocumentApi = (id) =>
//   request(`/documents/${id}`, {
//     method: "DELETE",
//   });

// /* ================= MONTHLY TASKS ================= */

// export const getMyMonthlyTasksApi = (month, year) =>
//   request(`/monthly-tasks/my?month=${month}&year=${year}`);

// export const setEmployeeOfTheMonthApi = (payload) =>
//   request("/monthly-tasks/employee-of-the-month", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getMonthlyLeaderboardApi = (month, year) =>
//   request(`/monthly-tasks/leaderboard?month=${month || ""}&year=${year || ""}`);

// export const getAllMonthlyReportsApi = (month, year) =>
//   request(`/monthly-tasks/all-reports?month=${month || ""}&year=${year || ""}`);

// export const completeMonthlyTaskApi = (id) =>
//   request(`/monthly-tasks/${id}/complete`, {
//     method: "POST",
//   });

// export const AdminMonthlyAttendanceApi = (month, year) =>
//   request(
//     `/attendance/admin-attendance/monthly-summary-table?month=${month}&year=${year}`
//   );







// /* ================= PROJECT APIs ================= */



// // export const createProjectApi = (formData) =>
// //   request("/Projects", {
// //     method: "POST",
// //     body: formData, // ✅ send FormData directly
// //   });



// // // ✅ GET ALL PROJECTS (if needed later)
// // export const getProjectsApi = () =>
// //   request("/Projects");




// // // ✅ GET MY PROJECTS (logged-in user)
// // export const getMyProjectsApi = () =>
// //   request("/Projects/my");


// // // ✅ GET PROJECT BY ID (optional)
// // export const getProjectByIdApi = (id) =>
// //   request(`/Projects/${id}`);



// // export const updateProjectApi = (id, data) =>
// //   request(`/Projects/${id}`, {
// //     method: "PUT",
// //     body: JSON.stringify(data), // ✅ FIXED
// //   });

// // // ✅ DELETE
// // export const deleteProjectApi = (id) =>
// //   request(`/Projects/${id}`, {
// //     method: "DELETE",
// //   });







// // ✅ CREATE APP
// export const createAppApi = (payload) =>
//   request("/appProjects", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });


// export const getAppProjectsApi = () =>
//   request("/appProjects");

// // ✅ GET APP BY ID
// export const getMyAppProjectsApi = () =>
//   request("/appProjects/my");









// // ✅ 🔥 UPDATE APP (ADD THIS)
// export const updateAppProjectApi = (id, payload) =>
//   request(`/appProjects/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });


// // ✅ 🔥 DELETE APP (ADD THIS)
// export const deleteAppProjectApi = (id) =>
//   request(`/appProjects/${id}`, {
//     method: "DELETE",
//   });






// // ✅ CREATE PROJECT
// export const createProjectApi = (formData) =>
//   request("/allProjects", {
//     method: "POST",
//     body: formData, // ✅ send FormData directly
//   });

// // ✅ GET ALL PROJECTS
// export const getProjectsApi = () =>
//   request("/allProjects");

// // ✅ GET MY PROJECTS (logged-in user)
// export const getMyProjectsApi = () =>
//   request("/allProjects/my");

// // ✅ GET PROJECT BY ID
// // export const getProjectByIdApi = (id) =>
// //   request(/allProjects/${id});

// export const getProjectByIdApi = (id) =>
//   request(`/allProjects/${id}`);

// // ✅ UPDATE
// export const updateProjectApi = (id, formData) =>
//   request(`/allProjects/${id}`, {
//     method: "PUT",
//     body: formData,
//   });

// // ✅ DELETE
// export const deleteProjectApi = (id) =>
//   request(`/allProjects/${id}`, {
//     method: "DELETE",
//   });






// /* ================= CHAT ================= */

// // 📥 Get chat history (user or group)
// export const getChatHistoryApi = ({ userId, groupId }) => {
//   if (groupId) {
//     return request(`/chat/groups/${groupId}/messages`);
//   }
//   if (userId) {
//     return request(`/chat/history/${userId}`);
//   }
// };

// // 👥 Get chat users
// export const getChatUsersApi = (search = "") =>
//   request(`/chat/users${search ? `?search=${encodeURIComponent(search)}` : ""}`);

// // 👨‍👩‍👧‍👦 Get groups
// export const getChatGroupsApi = () =>
//   request("/chat/groups");

// // ➕ Create group
// export const createChatGroupApi = (payload) =>
//   request("/chat/groups", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // ❌ Delete group
// export const deleteChatGroupApi = (groupId) =>
//   request(`/chat/groups/${groupId}`, {
//     method: "DELETE",
//   });

// // 👥 Get group members
// export const getGroupMembersApi = (groupId) =>
//   request(`/chat/groups/${groupId}/members`);

// // ➕ Add member to group
// export const addGroupMemberApi = (groupId, userId) =>
//   request(`/chat/groups/${groupId}/members`, {
//     method: "POST",
//     body: JSON.stringify({ userId }),
//   });

// // ❌ Remove member from group
// export const removeGroupMemberApi = (groupId, userId) =>
//   request(`/chat/groups/${groupId}/members/${userId}`, {
//     method: "DELETE",
//   });
// // ======journey====
// // export const getTaskActivityApi = (taskId) =>
// // request(`/tasks/${taskId}/activity`);

// export const getUserActivityApi = (userId) =>
//   request(`/tasks/user/${userId}/activity`);

// export const chatBulkUploadApi = (formData) =>
//   request("/documents/chat-bulk-upload", {
//     method: "POST",
//     body: formData,
//   });


// export const updateTaskStatusApi = (taskId, payload) =>
//   request(`/tasks/${taskId}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });


// /* ================= GRIEVANCE ================= */

// export const getGrievancesApi = () =>
//   request("/grievance");

// export const createGrievanceApi = (formData) =>
//   request("/grievance", {
//     method: "POST",
//     body: formData,
//   });

// export const updateGrievanceStatusApi = (id, payload) =>
//   request(`/grievance/${id}/status`, {
//     method: "PATCH",
//     body: JSON.stringify(payload),
//   });




// import Cookies from "js-cookie";

// const BASE_URL = "https://uptask.visiontrek.io/api";
// // const BASE_URL = "http://localhost:6655/api";
// // const BASE_URL = "http://192.168.1.16:6655/api";
// // const BASE_URL = "/api";
// export const FILE_BASE_URL = "https://uptask.visiontrek.io";
// /* ================= CORE REQUEST ================= */

// async function request(url, options = {}) {
//   const token = Cookies.get("token");

//   const res = await fetch(`${BASE_URL}${url}`, {
//     headers: {
//       Authorization: token ? `Bearer ${token}` : "",
//       ...(options.body instanceof FormData
//         ? {} // don't set content-type for multipart
//         : { "Content-Type": "application/json" }),
//       ...options.headers,
//     },
//     ...options,
//   });

//   let data = {};
//   if (res.status !== 204) {
//     try {
//       data = await res.json();
//     } catch (e) {
//       // Not JSON
//     }
//   }

//   if (res.status === 403) {
//     return { forbidden: true };
//   }

//   if (!res.ok) {
//     throw new Error(data.message || `Request failed with status ${res.status}`);
//   }


//   return data;
// }

// /* ================= AUTH ================= */

// export const loginApi = (body) =>
//   request("/users/login", {
//     method: "POST",
//     body: JSON.stringify(body),
//   });

// export const getProfileApi = () =>
//   request("/users/me");

// export const getChatUnreadApi = () =>
//   request("/chat/unread");

// // export const updateOfficeExpenseApi = (id, formData) =>
// // request(`/office-expense/${id}`, {
// //   method: "PUT",
// //   body: formData,
// // });


// // export const updateOwnProfileApi = async (payload) => {
// //   const token = Cookies.get("token");

// //   const res = await fetch(`${BASE_URL}/users/me`, {
// //     method: "PUT",
// //     headers: {
// //       Authorization: `Bearer ${token}`,
// //       // ❌ DO NOT set Content-Type
// //     },
// //     body: payload, // 👈 FormData directly
// //   });

// //   return res.json();
// // };

// export const updateOwnProfileApi = async (payload) => {
//   const res = await fetch(`${BASE_URL}/users/me`, {
//     method: "PUT",
//     credentials: "include",   // ✅ THIS IS THE KEY FIX
//     body: payload,
//   });

//   return res.json();
// };


// /* ================= USERS ================= */

// export const getUserByIdApi = (id) =>
//   request(`/users?id=${id}`);

// export const getEmployeesApi = () =>
//   request("/users");

// export const createUserApi = (payload) =>
//   request("/users", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const updateUserApi = (id, payload) =>
//   request(`/users/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteUserApi = (id) =>
//   request(`/users/${id}`, {
//     method: "DELETE",
//   });

// export const getExEmployeesApi = () =>
//   request("/users/ex");




// export const resetUserPasswordApi = async (userId, newPassword) => {
//   const token = Cookies.get("token");

//   const res = await fetch(
//     `${BASE_URL}/users/${userId}/reset-password`,
//     {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify({
//         new_password: newPassword,
//       }),
//     }
//   );

//   return res.json();
// };


// /* ================= DEPARTMENTS ================= */

// export const createDepartmentApi = (payload) =>
//   request("/departments", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getDepartmentsApi = () =>
//   request("/departments");

// export const updateDepartmentApi = (id, payload) =>
//   request(`/departments/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteDepartmentApi = (id) =>
//   request(`/departments/${id}`, {
//     method: "DELETE",
//   });

// /* ================= DASHBOARD ================= */

// export const getDashboardFeedsApi = () =>
//   request("/dashboard/feeds");

// /* ================= ATTENDANCE ================= */

// export const punchInApi = (formData) =>
//   request("/attendance/user-punch-in", {
//     method: "POST",
//     body: formData,
//   });

// export const punchOutApi = (formData) =>
//   request("/attendance/user-punch-out", {
//     method: "POST",
//     body: formData,
//   });


// export const autoPunchOutApi = () =>
//   request("/attendance/auto-punch-out", {
//     method: "POST",
//   });

// export const startBreakApi = () =>
//   request("/attendance/user-break/start", {
//     method: "POST",
//   });

// export const endBreakApi = () =>
//   request("/attendance/user-break/end", {
//     method: "POST",
//   });

// // export const getMyAttendanceApi = () =>
// //   request("/attendance/user-my");


// export const getMyAttendanceApi = (month, year) =>
//   request(`/attendance/user-my?month=${month}&year=${year}`);

// export const getMonthlySummaryApi = (month, year) =>
//   request(
//     `/attendance/user-summary/monthly?month=${month}&year=${year}`
//   );

// /* ================= ADMIN ATTENDANCE ================= */

// export const adminDailyAttendanceApi = (date) =>
//   request(`/attendance/admin-attendance/day?date=${date}`);

// export const adminMonthlyAttendanceApi = (month, year) =>
//   request(
//     `/attendance/admin-attendance/monthly?month=${month}&year=${year}`
//   );


// // ✅ USER MONTHLY DAILY ATTENDANCE (ADMIN)
// export const getUserMonthlyDailyAttendanceApi = (userId, month, year) =>
//   request(
//     `/attendance/admin-attendance/user-monthly-daily?user_id=${userId}&month=${month}&year=${year}`
//   );


// // http://localhost:5566/api/attendance/admin-attendance/user-monthly-daily?user_id=19&month=4&year=2026

// /* ================= LEAVES ================= */

// export const getLeaveTypesApi = () =>
//   request("/leave/types");

// export const getLeaveBalanceApi = () =>
//   request("/leave/balance");

// export const applyLeaveApi = (payload) =>
//   request("/leave/apply", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getMyLeavesApi = () =>
//   request("/leave/my");

// export const cancelLeaveApi = (id) =>
//   request(`/leave/cancel/${id}`, {
//     method: "POST",
//   });

// /* ================= ADMIN LEAVES ================= */

// export const adminPendingLeavesApi = () =>
//   request("/leave/pending");

// export const adminApproveLeaveApi = (leave_id) =>
//   request("/leave/approve", {
//     method: "POST",
//     body: JSON.stringify({ leave_id }),
//   });

// export const adminRejectLeaveApi = (leave_id, remarks) =>
//   request("/leave/reject", {
//     method: "POST",
//     body: JSON.stringify({ leave_id, remarks }),
//   });

// // export const adminLeaveReportApi = (filters = {}) => {
// //   const params = {
// //     employee_id: filters.search || "",
// //     status:
// //       filters.status !== ""
// //         ? Number(filters.status)
// //         : "",
// //     from_date: filters.start_date || "",
// //     to_date: filters.end_date || "",
// //   };

// //   const cleanParams = Object.fromEntries(
// //     Object.entries(params).filter(([_, v]) => v !== "")
// //   );

// //   const query = new URLSearchParams(cleanParams).toString();

// //   return request(`/leave/report?${query}`);
// // };
// export const adminLeaveReportApi = () => {
//   return request(`/leave/report`);
// };
// /* ================= EXPENSES ================= */

// export const createExpenseCategoryApi = (payload) =>
//   request("/office-expense/category", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getExpenseCategoriesApi = () =>
//   request("/office-expense/category");

// export const updateExpenseCategoryApi = (id, payload) =>
//   request(`/office-expense/category/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteExpenseCategoryApi = (id) =>
//   request(`/office-expense/category/${id}`, {
//     method: "DELETE",
//   });

// export const addOfficeExpenseApi = (formData) =>
//   request("/office-expense", {
//     method: "POST",
//     body: formData,
//   });

// export const listOfficeExpensesApi = () =>
//   request("/office-expense");

// export const updateOfficeExpenseApi = (id, formData) =>
//   request(`/office-expense/${id}`, {
//     method: "PUT",
//     body: formData,
//   });

// export const deleteOfficeExpenseApi = (id) =>
//   request(`/office-expense/${id}`, {
//     method: "DELETE",
//   });

// export const addOfficeWalletApi = (payload) =>
//   request("/office-expense/wallet", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getOfficeWalletHistoryApi = () =>
//   request("/office-expense/wallet");

// export const deleteOfficeWalletApi = (id) =>
//   request(`/office-expense/wallet/${id}`, {
//     method: "DELETE",
//   });

// export const getOfficeExpenseSummaryApi = () =>
//   request("/office-expense/summary");

// /* ================= TASKS ================= */

// export const getMyTasksApi = () =>
//   request("/tasks/my");

// export const getAllTasksApi = () =>
//   request("/tasks/all");

// // export const getTeamTasksApi = () =>
// //   request("/tasks/team");

// export const createTaskApi = (payload) =>
//   request("/tasks", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // export const updateTaskStatusApi = (taskId, payload) =>
// //   request(`/tasks/${taskId}`, {
// //     method: "PUT",
// //     body: JSON.stringify(payload),
// //   });


// // ✅ DELETE TASK
// export const deleteTaskApi = (taskId) =>
//   request(`/tasks/${taskId}`, {
//     method: "DELETE",
//   });


// export const getAdminUserTasksApi = (userId) =>
//   request(`/tasks/admin/user/${userId}`);


// /* ================= TASKS ================= */

// export const getAssignedTasksApi = () =>
//   request("/tasks/assigned");


// /* ================= SUBTASKS ================= */

// export const getSubtasksApi = (taskId) =>
//   request(`/tasks/${taskId}/subtasks`);

// export const addSubtaskApi = (taskId, payload) =>
//   request(`/tasks/${taskId}/subtasks`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const toggleSubtaskApi = (subtaskId, payload) =>
//   request(`/tasks/subtasks/${subtaskId}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const updateSubtaskApi = (subtaskId, payload) =>
//   request(`/tasks/subtasks/${subtaskId}/update`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteSubtaskApi = (subtaskId) =>
//   request(`/tasks/subtasks/${subtaskId}/delete`, {
//     method: "DELETE",
//   });

// /* ================= TASK ACTIVITY ================= */

// export const getTaskActivityApi = (taskId) =>
//   request(`/tasks/${taskId}/activity`);

// /* ================= TASK COMMENTS ================= */

// export const getTaskCommentsApi = (taskId) =>
//   request(`/tasks/${taskId}/comments`);

// export const addTaskCommentApi = (taskId, payload) =>
//   request(`/tasks/${taskId}/comment`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });





// // ======================dependanct task--------=====================
// export const addSubtaskDependencyApi = (subtaskId, payload) =>
//   request(`/tasks/subtasks/${subtaskId}/dependency`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });




// /* ================= TEAM COLLABORATION ================= */

// // 1. Create Team
// export const createTeamApi = (payload) =>
//   request("/teams", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // 2. Get All Teams
// export const getAllTeamsApi = () =>
//   request("/teams");

// // 3. Get Team Details
// export const getTeamDetailsApi = (teamId) =>
//   request(`/teams/${teamId}`);

// // 4. Add Member
// export const addTeamMemberApi = (teamId, payload) =>
//   request(`/teams/${teamId}/members`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // 5. Remove Member
// export const removeTeamMemberApi = (teamId, userId) =>
//   request(`/teams/${teamId}/members/${userId}`, {
//     method: "DELETE",
//   });

// // 6. Create Team Task
// export const createTeamTaskApi = (teamId, payload) =>
//   request(`/teams/${teamId}/tasks`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // 7. Get Team Tasks
// export const getTeamTasksApi = (teamId, page = 1, limit = 20, status = "") =>
//   request(
//     `/teams/${teamId}/tasks?page=${page}&limit=${limit}&status=${status}`
//   );


// export const getTeamTasksApi1 = () =>
//   request("/tasks/team");

// // 8. Team Analytics
// export const getTeamAnalyticsApi = (teamId) =>
//   request(`/teams/${teamId}/analytics`);

// // 9. Team Activity
// export const getTeamActivityApi = (teamId, page = 1, limit = 20) =>
//   request(`/teams/${teamId}/activity?page=${page}&limit=${limit}`);







// /* ================= PAYROLL ================= */

// // export const getEarningsApi = () =>
// //   request("/admin/payroll/earnings");

// // export const addEarningApi = (payload) =>
// //   request("/admin/payroll/earnings", {
// //     method: "POST",
// //     body: JSON.stringify(payload),
// //   });

// export const createSalaryApi = (payload) =>
//   request("/admin/payroll/salary", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const listSalariesApi = () =>
//   request("/admin/payroll/salary");

// export const getSalaryBreakdownApi = (uuid) =>
//   request(`/admin/payroll/salary/${uuid}`);



// // export const getPayrollSummaryApi = (fromMonth, toMonth) => {
// //   if (toMonth) {
// //     return request(`/payroll/summary?month=${fromMonth}&fromMonth=${fromMonth}&toMonth=${toMonth}`);
// //   }
// //   return request(`/payroll/summary?month=${fromMonth}`);
// // };

// export const getPayrollSummaryApi = (fromMonth, toMonth) => {
//   if (toMonth) {
//     return request(`/payroll/summary?fromMonth=${fromMonth}&toMonth=${toMonth}`);
//   }
//   request(`/payroll/summary?month=${fromMonth}`);
// };

// export const getPayrollRecordsApi = (fromMonth, toMonth) => {
//   if (toMonth) {
//     return request(`/payroll/monthly?fromMonth=${fromMonth}&toMonth=${toMonth}`);
//   }
//   return request(`/payroll/monthly?month=${fromMonth}`);
// };

// export const runPayrollApi = (payload) =>
//   request("/payroll/run", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getPayrollEmployeesApi = (month) =>
//   request(`/payroll/employees${month ? `?month=${month}` : ""}`);

// export const updatePayrollDetailsApi = (payload) =>
//   request("/payroll/details", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const editPayrollEmployeeApi = (id, payload) =>
//   request(`/payroll/employee/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const rerunPayrollApi = (payload) =>
//   request("/payroll/rerun", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const approvePayrollApi = (payload) =>
//   request("/payroll/approve", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const markPayrollPaidApi = (payload) =>
//   request("/payroll/paid", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const exportPayrollReportApi = async (fromMonth, toMonth) => {
//   const token = Cookies.get("token");
//   const url = toMonth
//     ? `${BASE_URL}/payroll/export?fromMonth=${fromMonth}&toMonth=${toMonth}`
//     : `${BASE_URL}/payroll/export?month=${fromMonth}`;
//   const res = await fetch(url, {
//     headers: {
//       Authorization: token ? `Bearer ${token}` : "",
//     },
//   });

//   if (!res.ok) throw new Error("Failed to export report");

//   const blob = await res.blob();
//   const downloadUrl = window.URL.createObjectURL(blob);
//   const link = document.createElement('a');
//   link.href = downloadUrl;
//   link.download = `Payroll_Report_${fromMonth}${toMonth ? `_to_${toMonth}` : ""}.xlsx`;
//   document.body.appendChild(link);
//   link.click();
//   link.remove();
//   window.URL.revokeObjectURL(downloadUrl);
// };

// export const getPayslipApi = (userId, month, year) =>
//   request(`/payroll/payslip?userId=${userId}&month=${month}&year=${year}`);

// export const getAllPayslipsApi = () =>
//   request("/payroll/all-payslips");


// /* ================= PAYROLL BONUS ================= */

// export const addBonusApi = (payload) =>
//   request("/payroll/bonus", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getMonthlyBonusApi = (month) =>
//   request(`/payroll/viewbonus?month=${month}`);

// export const updateBonusApi = (id, payload) =>
//   request(`/payroll/bonus/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });

// export const deleteBonusApi = (id) =>
//   request(`/payroll/bonus/${id}`, {
//     method: "DELETE",
//   });

// export const getLeaveSummaryApi = (employeeId) =>
//   request(`/leave/summary?employee_id=${employeeId}`);


// export const getUserMonthlyAttendanceApi = (month, year, employeeId) => {
//   let url = `/attendance/user-summary/monthly?month=${month}&year=${year}`;

//   if (employeeId) {
//     url += `&employee_id=${employeeId}`;
//   }

//   return request(url);
// };






// /* ================= ADMIN TASK ANALYTICS ================= */

// export const adminTaskAnalyticsApi = (filters = {}) => {
//   const params = {
//     completed:
//       filters.completed !== undefined
//         ? filters.completed
//         : "",
//     priority: filters.priority || "",
//     created_from: filters.created_from || "",
//     created_to: filters.created_to || "",
//     assigned_to: filters.assigned_to || "",
//     search: filters.search || "",
//   };

//   // remove empty values
//   const cleanParams = Object.fromEntries(
//     Object.entries(params).filter(([_, v]) => v !== "")
//   );

//   const query = new URLSearchParams(cleanParams).toString();

//   return request(`/tasks/admin/analytics?${query}`);
// };




// // ==========================posts===========================
// /* ================= FEEDS ================= */

// export const createFeedApi = (payload, isFormData = false) => {
//   const token = Cookies.get("token"); // ✅ get token
//   return fetch(`${BASE_URL}/feeds`, {
//     method: "POST",
//     headers: {
//       ...(isFormData ? {} : { "Content-Type": "application/json" }),
//       Authorization: `Bearer ${token}`, // ✅ always send token
//     },
//     body: payload,
//   }).then((res) => res.json());
// };



// export const getFeedsApi = () =>
//   request("/feeds");

// export const deleteFeedApi = (id) =>
//   request(`/feeds/${id}`, {
//     method: "DELETE",
//   });

// export const likeFeedApi = (id) =>
//   request(`/feeds/${id}/like`, {
//     method: "POST",
//   });

// export const unlikeFeedApi = (id) =>
//   request(`/feeds/${id}/like`, {
//     method: "DELETE",
//   });

// //   export const likeFeedApi = (id) =>
// //   request(/feeds/${id}/like, {
// //     method: "POST",
// //   });

// // export const unlikeFeedApi = (id) =>
// //   request(/feeds/${id}/like, {
// //     method: "POST",
// //   });

// export const addCommentApi = (id, payload) =>
//   request(`/feeds/${id}/comment`, {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// export const getCommentsApi = (id) =>
//   request(`/feeds/${id}/comments`);

// export const deleteCommentApi = (commentId) =>
//   request(`/feeds/comment/${commentId}`, {
//     method: "DELETE",
//   });

// /* ================= DOCUMENTS ================= */

// // Upload single document
// export const uploadDocumentApi = (formData) =>
//   request("/documents", {
//     method: "POST",
//     body: formData,
//   });

// // Upload multiple documents
// export const bulkUploadDocumentsApi = (formData) =>
//   request("/documents/bulk-upload", {
//     method: "POST",
//     body: formData,
//     // body: JSON.stringify(payload),
//     // body: JSON.stringify(payload),
//   });

// export const deleteMessageApi = (messageId) =>
//   request(`/chat/messages/${messageId}`, {
//     method: "DELETE",
//   });

// // Get documents for specific user
// export const getUserDocumentsApi = (userId) =>
//   request(`/documents/user/${userId}`);

// // View document
// export const viewDocumentApi = (userId) =>
//   request(`/documents/view/${userId}`);

// // export const viewDocumentApi = (userId) =>
// export const getAllDocumentsApi = () =>
//   request(`/documents/all`);

// // Delete document
// export const deleteDocumentApi = (id) =>
//   request(`/documents/${id}`, {
//     method: "DELETE",
//   });

// /* ================= MONTHLY TASKS ================= */

// export const getMyMonthlyTasksApi = (month, year) =>
//   request(`/monthly-tasks/my?month=${month || ""}&year=${year || ""}`);

// export const getMonthlyLeaderboardApi = (month, year) =>
//   request(`/monthly-tasks/leaderboard?month=${month || ""}&year=${year || ""}`);

// export const getAllMonthlyReportsApi = (month, year) =>
//   request(`/monthly-tasks/all-reports?month=${month || ""}&year=${year || ""}`);

// export const completeMonthlyTaskApi = (id) =>
//   request(`/monthly-tasks/${id}/complete`, {
//     method: "POST",
//   });

// export const AdminMonthlyAttendanceApi = (month, year) =>
//   request(
//     `/attendance/admin-attendance/monthly-summary-table?month=${month}&year=${year}`
//   );







// /* ================= PROJECT APIs ================= */



// // export const createProjectApi = (formData) =>
// //   request("/Projects", {
// //     method: "POST",
// //     body: formData, // ✅ send FormData directly
// //   });



// // // ✅ GET ALL PROJECTS (if needed later)
// // export const getProjectsApi = () =>
// //   request("/Projects");




// // // ✅ GET MY PROJECTS (logged-in user)
// // export const getMyProjectsApi = () =>
// //   request("/Projects/my");


// // // ✅ GET PROJECT BY ID (optional)
// // export const getProjectByIdApi = (id) =>
// //   request(`/Projects/${id}`);



// // export const updateProjectApi = (id, data) =>
// //   request(`/Projects/${id}`, {
// //     method: "PUT",
// //     body: JSON.stringify(data), // ✅ FIXED
// //   });

// // // ✅ DELETE
// // export const deleteProjectApi = (id) =>
// //   request(`/Projects/${id}`, {
// //     method: "DELETE",
// //   });







// // ✅ CREATE APP
// export const createAppApi = (payload) =>
//   request("/appProjects", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });


// export const getAppProjectsApi = () =>
//   request("/appProjects");

// // ✅ GET APP BY ID
// export const getMyAppProjectsApi = () =>
//   request("/appProjects/my");









// // ✅ 🔥 UPDATE APP (ADD THIS)
// export const updateAppProjectApi = (id, payload) =>
//   request(`/appProjects/${id}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });


// // ✅ 🔥 DELETE APP (ADD THIS)
// export const deleteAppProjectApi = (id) =>
//   request(`/appProjects/${id}`, {
//     method: "DELETE",
//   });






// // ✅ CREATE PROJECT
// export const createProjectApi = (formData) =>
//   request("/allProjects", {
//     method: "POST",
//     body: formData, // ✅ send FormData directly
//   });

// // ✅ GET ALL PROJECTS
// export const getProjectsApi = () =>
//   request("/allProjects");

// // ✅ GET MY PROJECTS (logged-in user)
// export const getMyProjectsApi = () =>
//   request("/allProjects/my");

// // ✅ GET PROJECT BY ID
// // export const getProjectByIdApi = (id) =>
// //   request(/allProjects/${id});

// export const getProjectByIdApi = (id) =>
//   request(`/allProjects/${id}`);

// // ✅ UPDATE
// export const updateProjectApi = (id, formData) =>
//   request(`/allProjects/${id}`, {
//     method: "PUT",
//     body: formData,
//   });

// // ✅ DELETE
// export const deleteProjectApi = (id) =>
//   request(`/allProjects/${id}`, {
//     method: "DELETE",
//   });






// /* ================= CHAT ================= */

// // 📥 Get chat history (user or group)
// export const getChatHistoryApi = ({ userId, groupId }) => {
//   if (groupId) {
//     return request(`/chat/groups/${groupId}/messages`);
//   }
//   if (userId) {
//     return request(`/chat/history/${userId}`);
//   }
// };

// // 👥 Get chat users
// export const getChatUsersApi = (search = "") =>
//   request(`/chat/users${search ? `?search=${encodeURIComponent(search)}` : ""}`);

// // 👨‍👩‍👧‍👦 Get groups
// export const getChatGroupsApi = () =>
//   request("/chat/groups");

// // ➕ Create group
// export const createChatGroupApi = (payload) =>
//   request("/chat/groups", {
//     method: "POST",
//     body: JSON.stringify(payload),
//   });

// // ❌ Delete group
// export const deleteChatGroupApi = (groupId) =>
//   request(`/chat/groups/${groupId}`, {
//     method: "DELETE",
//   });

// // 👥 Get group members
// export const getGroupMembersApi = (groupId) =>
//   request(`/chat/groups/${groupId}/members`);

// // ➕ Add member to group
// export const addGroupMemberApi = (groupId, userId) =>
//   request(`/chat/groups/${groupId}/members`, {
//     method: "POST",
//     body: JSON.stringify({ userId }),
//   });

// // ❌ Remove member from group
// export const removeGroupMemberApi = (groupId, userId) =>
//   request(`/chat/groups/${groupId}/members/${userId}`, {
//     method: "DELETE",
//   });
// // ======journey====
// // export const getTaskActivityApi = (taskId) =>
// // request(`/tasks/${taskId}/activity`);

// export const getUserActivityApi = (userId) =>
//   request(`/tasks/user/${userId}/activity`);

// export const chatBulkUploadApi = (formData) =>
//   request("/documents/chat-bulk-upload", {
//     method: "POST",
//     body: formData,
//   });


// export const updateTaskStatusApi = (taskId, payload) =>
//   request(`/tasks/${taskId}`, {
//     method: "PUT",
//     body: JSON.stringify(payload),
//   });


// /* ================= GRIEVANCE ================= */

// export const getGrievancesApi = () =>
//   request("/grievance");

// export const createGrievanceApi = (formData) =>
//   request("/grievance", {
//     method: "POST",
//     body: formData,
//   });

// export const updateGrievanceStatusApi = (id, payload) =>
//   request(`/grievance/${id}/status`, {
//     method: "PATCH",
//     body: JSON.stringify(payload),
//   });

